import React from "react"
export const MemberIconSvg = ({
    size = 24,
    color,
    style,
}: {
    size?: number
    color?: string
    style?: React.CSSProperties
}) => (
    // aspect ratio: 125/100 = 1.25
    <svg
        // viewBox="0 0 100 125"
        viewBox='0 0 100 100'
        width={size / 1.25}
        height={size}
        style={{ ...style, marginBottom: -size / 3 }}
    >
        <path
            d='m14.789 50c0-19.445 15.766-35.211 35.211-35.211s35.211 15.766 35.211 35.211c0 9.2734-3.582 17.703-9.4375 23.992-1.1758 1.2617-1.1094 3.2422 0.15625 4.418 1.2617 1.1758 3.2383 1.1055 4.4141-0.15625 6.8945-7.4023 11.117-17.34 11.117-28.254 0-22.898-18.562-41.461-41.461-41.461s-41.461 18.562-41.461 41.461c0 10.914 4.2227 20.852 11.117 28.254 1.1758 1.2617 3.1523 1.332 4.4141 0.15625 1.2656-1.1758 1.332-3.1562 0.15625-4.418-5.8594-6.2891-9.4375-14.719-9.4375-23.992zm25.383-4.9961c0-5.4258 4.4023-9.8281 9.8281-9.8281s9.8281 4.4023 9.8281 9.8281c0 5.418-4.3867 9.8125-9.8047 9.8242h-0.046876c-5.418-0.011719-9.8047-4.4062-9.8047-9.8242zm25.906 0c0 4.6055-1.9375 8.7578-5.0391 11.688 4.5 1.5703 8.5664 4.0703 11.961 7.2695 1.2539 1.1875 1.3125 3.1641 0.12891 4.418-1.1836 1.2578-3.1641 1.3164-4.418 0.12891-4.8789-4.6016-11.449-7.4219-18.684-7.4297l-0.027344 0.003906-0.027344-0.003906c-7.2344 0.007813-13.805 2.8281-18.684 7.4297-1.2539 1.1875-3.2344 1.1289-4.418-0.12891-1.1836-1.2539-1.125-3.2305 0.12891-4.418 3.3945-3.1992 7.4609-5.6992 11.961-7.2695-3.1016-2.9297-5.0391-7.082-5.0391-11.688 0-8.8789 7.1992-16.078 16.078-16.078s16.078 7.1992 16.078 16.078zm-2.2539 29.043c1.2188-1.2188 1.2188-3.1992 0-4.418-1.2227-1.2227-3.1992-1.2227-4.4219 0l-10.961 10.961-5.0195-5.0156c-1.2188-1.2188-3.1992-1.2188-4.418 0-1.2188 1.2227-1.2188 3.1992 0 4.418l7.2266 7.2266c0.58594 0.58984 1.3828 0.91797 2.2109 0.91797s1.6211-0.32812 2.207-0.91797z'
            fill={color ?? "currentColor"}
        />
    </svg>
)

export const PrerequisiteCoursesIconSvg = ({
    size = 24,
    color,
    style,
}: {
    size?: number
    color?: string
    style?: React.CSSProperties
}) => (
    <svg width={size} height={size} viewBox='10 30 90 65' fill={color} style={style}>
        <path
            d='M84.375,18.75L15.625,18.75C10.457,18.75 6.25,22.957 6.25,28.125L6.25,71.875C6.25,77.043 10.457,81.25 15.625,81.25L84.375,81.25C89.543,81.25 93.75,77.043 93.75,71.875L93.75,28.125C93.75,22.957 89.543,18.75 84.375,18.75ZM87.5,71.875C87.5,73.598 86.098,75 84.375,75L15.625,75C13.902,75 12.5,73.598 12.5,71.875L12.5,28.125C12.5,26.402 13.902,25 15.625,25L84.375,25C86.098,25 87.5,26.402 87.5,28.125L87.5,71.875Z'
            transform='translate(5.47844,10.0172)'
        />
        <path
            d='M49.246,43.438L41.414,41.34L37,34.536C35.848,32.766 32.91,32.766 31.758,34.536L27.344,41.34L19.512,43.438C18.488,43.711 17.676,44.485 17.348,45.489C17.019,46.497 17.226,47.602 17.89,48.422L22.996,54.727L22.57,62.825C22.516,63.883 23,64.895 23.855,65.516C24.715,66.137 25.824,66.286 26.812,65.907L34.375,63.001L41.945,65.907C42.308,66.047 42.687,66.114 43.066,66.114C43.715,66.114 44.359,65.911 44.902,65.516C45.758,64.895 46.242,63.883 46.187,62.825L45.762,54.727L50.867,48.422C51.531,47.602 51.738,46.497 51.41,45.489C51.082,44.485 50.269,43.715 49.246,43.438ZM40.148,51.727C39.664,52.325 39.414,53.087 39.457,53.856L39.695,58.344L35.496,56.735C35.137,56.598 34.754,56.528 34.375,56.528C33.996,56.528 33.613,56.598 33.254,56.735L29.055,58.344L29.293,53.856C29.332,53.083 29.086,52.325 28.601,51.727L25.769,48.231L30.113,47.067C30.859,46.868 31.504,46.399 31.926,45.751L34.375,41.981L36.824,45.754C37.246,46.403 37.891,46.872 38.637,47.071L42.98,48.235L40.148,51.727Z'
            transform='translate(5.47844,10.0172)'
        />
        <path
            d='M70.312,53.125L60.937,53.125C59.21,53.125 57.812,54.523 57.812,56.25C57.812,57.977 59.21,59.375 60.937,59.375L70.312,59.375C72.039,59.375 73.437,57.977 73.437,56.25C73.437,54.523 72.039,53.125 70.312,53.125Z'
            transform='translate(5.47844,10.0172)'
        />
        <path
            d='M79.688,40.625L60.938,40.625C59.211,40.625 57.813,42.023 57.813,43.75C57.813,45.477 59.211,46.875 60.938,46.875L79.688,46.875C81.415,46.875 82.813,45.477 82.813,43.75C82.813,42.023 81.415,40.625 79.688,40.625Z'
            transform='translate(5.47844,10.0172)'
        />
    </svg>
)
